import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Member, Role, UpdateMember } from "@/model";
import { useUpdateMember } from "@/query/member";
import { useAgentId, useModal } from "@/hook";
import Button from "@/component/Button";
import { Modal } from "@/component/modal";
import { errorToast, successToast } from "@/component/Toast";

import RoleDropDown from "./RoleDropDown";


export const MEMBER_MODIFY_MODAL_ID = "member-modify-modal-id";

const MemberModifyModal: React.FC = () => {
    const intl = useIntl();
    const agentId = useAgentId();
    const modal = useModal();
    const member = modal.getData(MEMBER_MODIFY_MODAL_ID) as Member | undefined;

    const [role, setRole] = useState<Role>();

    const { mutateAsync: updateMember, isPending: isUpdating } = useUpdateMember(agentId);

    const onClickConfirm = async () => {
        if (!role || !member){
            return;
        }

        const form: UpdateMember = {
            role_id: role._id ?? role.id,
            member_id: member._id,
            default: role.default ?? true
        };

        await updateMember(form)
            .then(() => {
                successToast(intl.formatMessage({ id: "t003" }));
                modal.close(MEMBER_MODIFY_MODAL_ID);
            })
            .catch(() => {
                errorToast(intl.formatMessage({ id: "t004" }));
            });
    };

    useEffect(() => {
        if (!member?.roles.length){
            return;
        }
        setRole(member.roles[0]);
    }, [member]);

    return (
        <Modal id={MEMBER_MODIFY_MODAL_ID}
               size="md"
               title={intl.formatMessage({ id: "i12015" })}
               onClose={() => setRole(undefined)}
        >
            <div className="modal-body-8">
                <div className="flex flex-col gap-6">
                    <div className="flex flex-col gap-1.5">
                        <span className="input-group-heading">
                            {intl.formatMessage({ id: "i12016" })}
                        </span>
                        <span className="modal-description py-2">
                            {member?.user.username}
                        </span>
                    </div>
                    <div className="flex flex-col gap-1.5">
                        <span className="input-group-heading">
                            {intl.formatMessage({ id: "i12031" })}
                        </span>
                        <span className="modal-description py-2">
                            {member?.user.nickname}
                        </span>
                    </div>
                    <div className="flex flex-col gap-1.5">
                        <div className="input-group-heading">
                            {intl.formatMessage({ id: "i12024" })}
                        </div>
                        <RoleDropDown role={role}
                                      onChange={setRole}
                        />
                    </div>
                </div>
                <div className="modal-btn-group">
                    <Button variant="secondary"
                            size="sm"
                            disabled={isUpdating}
                            onClick={() => modal.close(MEMBER_MODIFY_MODAL_ID)}
                    >
                        {intl.formatMessage({ id: "b0002" })}
                    </Button>
                    <Button variant="primary"
                            size="sm"
                            disabled={isUpdating}
                            onClick={onClickConfirm}
                    >
                        {intl.formatMessage({ id: "b0001" })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default MemberModifyModal;